/**
 * @fileoverview Barrel exports for structural-refresh-composite-v1.
 *
 * This composite agent orchestrates two primitives:
 * - divergence-report-v2: Diagnoses structural drift
 * - structural-suggestions-v1: Proposes structural changes
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow } from './flow';

